<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="App_head"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="App_head"></router-view>

    <!-- <van-popup v-model="signInShow">
      <div></div>
    </van-popup> -->
  </div>
</template>
<script>
import { Row, Col, Tabbar, TabbarItem, Toast, Popup } from "vant";
export default {
  name: "App",
  data() {
    return {
      aaa: "#A10000",
      signInShow:false
    };
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
  },
  created() {},
  computed: {
    onRoutes() {}
  },
  mounted() {
  },
  methods: {}
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  background: #f6f3f3;
  min-height: 100vh;
  font-size: 14px;
}

.van-tabbar-item--active {
  color: #a10000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue